import { render, staticRenderFns } from "./permitting-templates.vue?vue&type=template&id=5b3df5da&scoped=true"
import script from "./permitting-templates.vue?vue&type=script&lang=js"
export * from "./permitting-templates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3df5da",
  null
  
)

export default component.exports